import {FC, useState, useEffect} from 'react'

import Image from '../../../../../pana/assets/img/bg-profile-pana.png'

type Props = {
  data: any
}

const ProfilePanaContent: FC<Props> = ({data}) => {
  return (
    <div style={{background: '#FFFFFF', borderRadius: '6.18px'}}>
      <div
        className='p-5 row'
        style={{
          backgroundImage: `url(${Image})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          border: '1px solid #D8DCE8',
          borderRadius: '15px',
          backgroundPosition: 'center',
        }}
      >
        <div className='col-md-10 col-sm-12 col-xs-12'>
          <div className='d-flex justify-content-start'>
            <div style={{marginLeft: '15px'}} className='mt-2'>
              <img
                src={require('../../../../../pana/assets/img/avatar-pana.png')}
                alt='PANA'
                id='avatar-image'
              />
            </div>

            {data?.pendaftaran_locus_temas?.map((item: any, key: any) => {
              if (item?.prioritas != 1) {
                return null
              }

              return (
                <div className='p-5'>
                  <span className='h6'>{item?.locus?.parent_locus?.tema_program ?? ''}</span>

                  <p style={{textTransform: 'capitalize'}}>
                    {data?.tipe} &#x2022; {data?.nomor_pendaftaran ?? '-'}
                  </p>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

const ProfilePana: FC<Props> = ({data}) => {
  return <ProfilePanaContent data={data} />
}

export default ProfilePana
